import React, { useEffect } from "react";
import RequestImage from "../assets/Images/request_submitted.png";
import Footer from "../components/Footer";
import { Stack, Typography, Container } from "@mui/material";
import Navbar from "../components/Navbar";
import ShowRouting from "../components/ShowRouting";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import PageHeader from "../components/PageHeader";

const RequestSubmitted = () => {
  const navigate = useNavigate();
  useEffect(() => {
    let user = {};
    user = JSON.parse(localStorage.getItem("user-info"));
    if (_.isEmpty(user)) {
      navigate("/login");
    }
  }, []);
  return (
    <>
      <PageHeader />
      <Container>
        <div>
          <Stack className="d-flex">
            <Typography
              variant="h5"
              gutterBottom
              component="div"
              className="t-a-c"
            >
              Request Posted
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              component="div"
              className="t-a-c"
            >
              Your request is posted and you will soon receive biddings from the
              experts.
            </Typography>
          </Stack>

          <div className="t-a-c">
            <img src={RequestImage} alt="MenuIcon" />
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default RequestSubmitted;
